import type { Time } from "../types/Units"

/**
 * Creates a UTC Unix timestamp (seconds since epoch)
 * @param date - Optional Date object. If undefined, uses current time
 * @returns Time branded number representing UTC Unix time
 */
export const UnixTime = (date?: Date): Time =>
  ((date ? date.getTime() : Date.now()) / 1000) as Time
